import type { MessageKey } from 'types/LocaleMessageKey';

interface GalleryImage {
  alt: MessageKey;
  caption: MessageKey;
  src: string;
}

export const galleryImages: GalleryImage[] = [
  {
    alt: 'oura_app',
    caption: 'oura_app',
    src: 'careers/desktop_carousel-image-1',
  },
  {
    alt: 'oura_ring_heritage_silver',
    caption: 'oura_ring_heritage_silver',
    src: 'careers/desktop_carousel-image-2',
  },
  {
    alt: 'know_why_you_feel',
    caption: 'know_why_you_feel',
    src: 'careers/desktop_carousel-image-3',
  },
  {
    alt: 'oura_ring_balance_black',
    caption: 'oura_ring_balance_black',
    src: 'careers/desktop_carousel-image-4',
  },
];
